import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-sicurezza',
    templateUrl: './sicurezza.component.html',
    styleUrls: ['./sicurezza.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class SicurezzaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
